export default () => ({
  type: 'filter-reset-button',
  placeholder: 'Reset filter',
  'max-width': '146px',
});
